import { render } from "./role_permissions.vue?vue&type=template&id=b33f85de&scoped=true"
import script from "./role_permissions.vue?vue&type=script&lang=js"
export * from "./role_permissions.vue?vue&type=script&lang=js"

import "./role_permissions.vue?vue&type=style&index=0&id=b33f85de&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33f85de"]])

export default __exports__